import { introTextBlock as schema } from 'web/schemas/contentful/_schema.mjs';
import { fakeProps } from 'web/schemas/contentfulTestData';

const TestData = {
  eyebrow: 'Overview & Mission',
  header: 'Historic charm meets unrivaled modern luxuries.',
  bodyText:
    'As one of the most popular areas in North West Denver, Highland is famous for the Highlands Square, and the Historic Elitch Gardens Theater. In the park, the original carousel housing has been renovated and is now a favorite place for concerts and other public performances. Residents of Highland say that there is an excellent balance between nightlife and quiet suburban feel in the neighborhood.',
  swatch: 'cream',
};

export default fakeProps(schema, TestData);
